import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-loading-indicator',
  template: `<div class="loader"></div>`,
  styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent {}
